import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs'
import {filter} from 'rxjs/operators'

type ConnectionStatus = 'initial' | 'connecting' | 'connected' | 'disconnected'

/**
 * Service providing information about the global websocket connection status.
 *
 * For now the web-ui must only have a single connection!
 */
@Injectable({
  providedIn: 'root',
})
export class GraphqlWebsocketStatusService {
  private readonly connectionStatus = new BehaviorSubject<ConnectionStatus>('initial')

  connectionStatus$ = this.connectionStatus.asObservable()
  successfullyConnected$ = this.connectionStatus$.pipe(filter(status => status === 'connected'))

  isConnected() {
    return this.connectionStatus.value === 'connected'
  }

  _updateStatus(status: ConnectionStatus) {
    this.connectionStatus.next(status)
  }
}
